import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('MainContainer')(({ theme }) =>
  css({
    zIndex: '1',
    display: 'inline-flex',
    flexDirection: 'column',
    width: '100%',
    border: `1px solid ${theme.colors.grey[3]}`,
    borderRadius: '3px',
    position: 'relative',
    img: {
      width: '100%',
      height: ['100px', '100px', '164px'],
    },
    padding: 'default',
    marginBottom: 'm',
    '&:hover': {
      border: [
        `1px solid ${theme.colors.grey[3]}`,
        `1px solid ${theme.colors.grey[3]}`,
        `1px solid ${theme.colors.blue}`,
      ],
    },
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.aodaFocused}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('TextContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    px: '16px',
    pb: '16px',
    pt: ['s', 's', 'm'],
    rowGap: ['64px', '64px', '50px'],
  }),
);

themeStyles.addBaseStyles('ProtectionReadMore')(() =>
  css({
    pb: 'm',
  }),
);

themeStyles.addBaseStyles('ProtectionAddon')(() =>
  css({
    marginRight: 'l',
  }),
);

themeStyles.addBaseStyles('ProtectionCheckbox')(() =>
  css({
    display: 'flex',
    alignItems: 'center',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('ProtectionTitle')(() =>
  css({
    mt: 'xs',
    mb: 'xxs',
    pr: ['30px', '30px', '40px'],
  }),
);

themeStyles.addBaseStyles('ProtectionDescription')(({ opened }) =>
  css({
    pb: 'zero',
    ...(!opened && {
      height: ['48px', '48px', '52px'],
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': '2',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '-webkit-line-break': 'after-white-space', // fix for iOS version 16 and below
    }),
  }),
);

themeStyles.addBaseStyles('ProtectionDescriptionWrapper')(({ opened }) =>
  css({
    height: opened ? 'initial' : ['48px', '48px', '52px'],
    overflow: 'hidden',
  }),
);

themeStyles.addBaseStyles('PriceContainer')(
  css({
    display: 'flex',
    flexDirection: 'row',
    pt: 'xs',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('VideoContainer')(
  css({
    py: 'm',
  }),
);

themeStyles.addBaseStyles('AddToBuildIcon')(() =>
  css({
    width: ['34px', '34px', '45px'],
    height: ['34px', '34px', '45px'],
  }),
);

export default themeStyles;
